/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PageDataNoteVo } from './PageDataNoteVo';
import {
    PageDataNoteVoFromJSON,
    PageDataNoteVoFromJSONTyped,
    PageDataNoteVoToJSON,
    PageDataNoteVoToJSONTyped,
} from './PageDataNoteVo';

/**
 * 
 * @export
 * @interface ResponsePageDataNoteVo
 */
export interface ResponsePageDataNoteVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponsePageDataNoteVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponsePageDataNoteVo
     */
    message?: string;
    /**
     * 
     * @type {PageDataNoteVo}
     * @memberof ResponsePageDataNoteVo
     */
    data?: PageDataNoteVo;
}

/**
 * Check if a given object implements the ResponsePageDataNoteVo interface.
 */
export function instanceOfResponsePageDataNoteVo(value: object): value is ResponsePageDataNoteVo {
    return true;
}

export function ResponsePageDataNoteVoFromJSON(json: any): ResponsePageDataNoteVo {
    return ResponsePageDataNoteVoFromJSONTyped(json, false);
}

export function ResponsePageDataNoteVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsePageDataNoteVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : PageDataNoteVoFromJSON(json['data']),
    };
}

export function ResponsePageDataNoteVoToJSON(json: any): ResponsePageDataNoteVo {
    return ResponsePageDataNoteVoToJSONTyped(json, false);
}

export function ResponsePageDataNoteVoToJSONTyped(value?: ResponsePageDataNoteVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': PageDataNoteVoToJSON(value['data']),
    };
}

